import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'mobileBarcodeScanModal.title',
    defaultMessage: 'Scanner un code-barres',
  },
  close: {
    id: 'mobileBarcodeScanModal.close',
    defaultMessage: 'Fermer',
  },
  cameraUnavailable: {
    id: 'mobileBarcodeScanModal.cameraUnavailable',
    defaultMessage: "La caméra n'est pas disponible dans ce navigateur.",
  },
  cameraPermissionDenied: {
    id: 'mobileBarcodeScanModal.cameraPermissionDenied',
    defaultMessage:
      "Impossible d'activer la caméra. Vérifiez les permissions ou utilisez une connexion sécurisée (HTTPS).",
  },
  detectorUnsupported: {
    id: 'mobileBarcodeScanModal.detectorUnsupported',
    defaultMessage:
      'La lecture automatique nécessite un navigateur compatible (ex. Chrome sur Android). Cadrez le code devant la caméra.',
  },
  detectorInitFailed: {
    id: 'mobileBarcodeScanModal.detectorInitFailed',
    defaultMessage:
      "Impossible d'initialiser la détection des codes-barres. La caméra reste ouverte pour aide visuelle.",
  },
});

export default messages;
